import { useCallback } from 'react';

import { useDeleteOrder } from 'api/requests';
import { OrderEntity } from 'api/types/entity';
import { useServerErrorNotify } from 'hooks';
import { ROUTES, useNavigate } from 'libs/navigation';
import { useDialog } from 'libs/ui/Dialog/useDialog';

export const useDeleteOrderAction = (order: OrderEntity | null) => {
  const { canGoBack, navigate, goBack } = useNavigate();

  const { deleteOrder, error, loading: loadingDelete } = useDeleteOrder();

  const {
    isOpen: isOpenDialogConfirmDelete,
    onClose: onCloseDialogConfirmDelete,
    open: openDialogConfirmDelete,
  } = useDialog();

  const onDelete = useCallback(async () => {
    if (await deleteOrder(order!.id, order!.versionNumber!)) {
      if (canGoBack) {
        goBack();
      } else {
        navigate(ROUTES.account.orders.fullPath, {});
      }
    }
  }, [canGoBack, deleteOrder, goBack, navigate, order]);

  useServerErrorNotify(error);

  return {
    loadingDelete,
    isOpenDialogConfirmDelete,
    onCloseDialogConfirmDelete,
    onOpenDialogConfirmDelete: openDialogConfirmDelete,
    onDelete,
  };
};
